// removed by extract-text-webpack-plugin
module.exports = {"root":"_3GkyluT3_6DjPAmZTiEFjV","label":"_2cjItTfiTHG1o9rhtZKFq9","checkbox":"_2qZuwwrDCQ9CWx0mgLgxVE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/check-box.scss
// module id = 1167
// module chunks = 0